import { inherits as _inherits, createClass as _createClass, extends as _extends, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '../Form/Form.js';
import { MultilingualForm } from '../Form/MultilingualForm.js';
import Modal from 'react-bootstrap/Modal';
import { ModalHeader } from '../ModalHeader.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var LegacyModalForm = /*#__PURE__*/function (_React$Component) {
  function LegacyModalForm(props) {
    var _this;

    _classCallCheck(this, LegacyModalForm);

    _this = _callSuper(this, LegacyModalForm, [props]);

    _defineProperty(_this, "buildForm", function () {
      if (_this.props.data) {
        var commonProps = {
          buttonGroupClass: 'modal-footer sticky-footer',
          fieldGroupClass: 'modal-body',
          horizontal: true,
          onCancel: _this.onCancel,
          onCancelClose: _this.onCancelClose,
          scrollContainerId: 'form-modal',
          saveAndAddButton: _this.props.saveAndAddButton !== undefined ? _this.props.saveAndAddButton : !_this.props.data.id,
          triggerCancel: _this.state.triggerCancel
        };

        if (_this.props.languages) {
          return /*#__PURE__*/React.createElement(MultilingualForm, _extends({}, _this.props, commonProps), _this.props.children);
        } else {
          return /*#__PURE__*/React.createElement(Form, _extends({}, _this.props, commonProps), _this.props.children);
        }
      }
    });

    _defineProperty(_this, "onCancelClose", function () {
      return _this.setState({
        triggerCancel: false
      });
    });

    _defineProperty(_this, "onCancel", function () {
      _this.setState({
        triggerCancel: false
      });

      _this.props.onCancel();
    });

    _defineProperty(_this, "onHide", function () {
      return _this.setState({
        triggerCancel: true
      });
    });

    _defineProperty(_this, "getModalClasses", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          size = _this$props.size;
      return _formatClassName(["".concat(className), 'form-modal', "modal-size-".concat(size)]);
    });

    _this.state = {};
    return _this;
  }

  _inherits(LegacyModalForm, _React$Component);

  return _createClass(LegacyModalForm, [{
    key: "render",
    value: function render() {
      var modalClassName = this.getModalClasses();
      var dataAttributes = pickDataAttributes(this.props);
      return /*#__PURE__*/React.createElement(Modal, {
        animation: false,
        size: this.props.bsSize,
        className: modalClassName,
        container: this.props.container,
        id: "form-modal",
        onHide: this.onHide,
        show: this.props.show === undefined ? !!this.props.data : this.props.show,
        enforceFocus: this.props.enforceFocus
      }, /*#__PURE__*/React.createElement(ModalHeader, _extends({}, dataAttributes, {
        canClickOff: true,
        onCancel: this.onHide,
        title: this.props.title
      })), this.buildForm());
    }
  }]);
}(React.Component);

_defineProperty(LegacyModalForm, "propTypes", {
  bsSize: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
  container: PropTypes.node,
  data: PropTypes.object,
  enforceFocus: PropTypes.bool,
  languages: PropTypes.arrayOf(PropTypes.object),
  modalProps: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  saveAndAddButton: PropTypes.bool,
  show: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string
});

_defineProperty(LegacyModalForm, "defaultProps", {
  container: null,
  size: 'medium',
  enforceFocus: true
});

LegacyModalForm.displayName = "LegacyModalForm";
export { LegacyModalForm };